module.exports = __webpack_public_path__ + "static/media/golfer-6-a.260b18b3.png";